import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { IStoreCustomers } from 'interfaces'
import { TStoreCustomersProps } from 'services/MarketService'
import * as userSelectors from 'containers/User/user-selectors'
import { MarketService } from 'services'
import { getRequestError } from 'utils/helpers'

export type TFetchFnParams = TStoreCustomersProps
export type TError = string
export type TQueryKey = [string, TFetchFnParams] | string[]
export type TQueryFnOpts = UseQueryOptions<IStoreCustomers, TError, IStoreCustomers, TQueryKey>

const key = 'store-customers'

/**
 * Хук API получение списка покупателей
 */
export default function useFetchStoreCustomers(params: TFetchFnParams, {
    cacheTime = 600 * 1000, // 10m
    staleTime = 600 * 1000, // 10m
    ...opts
}: TQueryFnOpts = {}) {
    const { t } = useTranslation()
    const user = useSelector(userSelectors.user)

    return useQuery([`${key}-${user.id}`, params], () => {
        return MarketService.fetchOrderStoreCustomers(params)
            .then(({ data }) => {
                return data
            })
            .catch((err) => {
                return Promise.reject(getRequestError(err) || t('update_error'))
            })
    }, {
        cacheTime,
        staleTime,
        ...opts,
    })
}
